module.exports = __webpack_public_path__ + "assets/img/202110-5W.0346b9b8.png";